<template>
    <v-container fluid class="fill-height">
        <v-row justify="center">
            <v-col>
                <v-card class="mx-auto my-6" max-width="400">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Delete Account</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="deleteAccount">
                            <v-text-field v-model="username" name="username" label="Username" type="text"
                                placeholder="username" required></v-text-field>
                            <v-text-field v-model="password" name="password" label="Password" type="password"
                                placeholder="password" required ></v-text-field>
                            <v-btn type="submit" class="mt-4" color="error" value="delete">Delete Account</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Delete Account">
                <v-card-text>Are you sure you whant to delete the account</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                    <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" >{{ apiFailed }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>


<script>
import Account from '../services/Account'
import { useStore } from '../services/store'


export default {
    name: "DeleteAccount",
    data() {
        return {
            username: "",
            password: "",
            apiFailed: "",
            timeout: 2000,
            dialogOn: false,
            snackbar: false,
            rules: {
                counter: () => { console.log(this.apiFailed); return this.apiFailed; }
            }
        };
    },
    methods: {
        deleteAccount() {
            this.dialogOn = true
        },
        confirmDelete() {
            Account.deleteAccount(this.username, this.password).then(res => {
                if(res.data && res.data.state) {
                    if(res.data.state.status == 'Success') {
                        this.snackbar =  true
                        this.apiFailed = res.data.state.message
                         const store = useStore();
                        localStorage.removeItem('access_token')
                        localStorage.removeItem('refresh_token')
                        store.organization = 0;
                        
                        this.$router.push('/delete-account/success')
                    }
                    else {
                        this.snackbar =  true
                        this.apiFailed = ` ${res.data.state.status} - ${res.data.state.message} `
                    }
                }
                
            }).finally( () => {
                this.dialogOn = false
            });
        }
    },
};
</script>